export const PRO_APPLICATION_LINK = 'https://form.jotform.com/243013753562048';

export const VERIFICATION_LINK = '/verify';
